export default "static/media/debate-timer.78b7323.svg"